<template>
  <div>
    <AccordionCard :state="cards.approvedAuxiliaryRafterUsedState">
      <template v-slot:header>
        {{ $t('approvedAuxiliaryRafterUsedState') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('approvedAuxiliaryRafterUsedState') }}
        </div>
        <div class="flex-column select">
          <SelectButton
            v-model="project.qualityReport.approvedAuxiliaryRafterUsedState"
            :options="getEnumValues('YesNoNonVerifiable')"
          >
            <template #option="props">
              {{ $t(props.option) }}
            </template>
          </SelectButton>
        </div>
        <div class="flex-row"></div>
        <div class="flex-row">
          <div class="flex-column name">
            {{ $t('annotations') }}
          </div>
          <div class="flex-column select">
            <Textarea
              v-model="project.qualityReport.approvedAuxiliaryRafterUsedNote"
              :autoResize="true"
              rows="5"
              cols="30"
            />
          </div>
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.rafterWidthMeasuredAndComparedToDocsState">
      <template v-slot:header>
        {{ $t('rafterWidthMeasuredAndComparedToDocsState') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('rafterWidthMeasuredAndComparedToDocsState') }}
        </div>
        <div class="flex-column select">
          <SelectButton
            v-model="project.qualityReport.rafterWidthMeasuredAndComparedToDocsState"
            :options="getEnumValues('YesNoNonVerifiable')"
          >
            <template #option="props">
              {{ $t(props.option) }}
            </template>
          </SelectButton>
        </div>
        <div class="flex-row"></div>
        <div class="flex-row">
          <div class="flex-column name">
            {{ $t('annotations') }}
          </div>
          <div class="flex-column select">
            <Textarea
              v-model="project.qualityReport.rafterWidthMeasuredAndComparedToDocsNote"
              :autoResize="true"
              rows="5"
              cols="30"
            />
          </div>
        </div>
      </div>
    </AccordionCard>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AccordionCard from '@/components/AccordionCard';
import SelectButton from 'primevue/selectbutton';
import Textarea from 'primevue/textarea';

export default {
  name: 'SubstructureQualityReportAccordions',
  components: {
    AccordionCard,
    SelectButton,
    Textarea,
  },
  props: {
    project: { type: Object },
    cards: { type: Object },
  },
  computed: {
    ...mapGetters(['getEnumValues']),
  },
};
</script>

<style lang="scss" scoped></style>
